import { useState } from "react";
import { Box, InputBase, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { makeStyles } from "@mui/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
const Properties = ({ formik }) => {
  const classes = useStyles();
  const [inputFields, setInputFields] = useState([]);
  const maxInputFields = 2;
  const [isAddingBackground, setIsAddingBackground] = useState(true);

  const handleAddClick = () => {
    if (inputFields.length < maxInputFields) {
      setInputFields([
        ...inputFields,
        {
          id: inputFields.length,
          background: "",
          color: "",
          isBackground: isAddingBackground,
        },
      ]);
      setIsAddingBackground(!isAddingBackground);
    }
  };

  const handleInputChange = (id, key, value) => {
    const updatedFields = inputFields.map((field) =>
      field.id === id ? { ...field, [key]: value } : field
    );
    setInputFields(updatedFields);
  };

  return (
    <>
      <Box className={classes.mainContainer}>
        <Box className={classes.propertiesContainer}>
          <Box className={classes.container}>
            <Typography> Properties</Typography>
            <Typography sx={{ display: "flex", alignItems: "center", gap: 5 }}>
              <span>Click on the add Icon for properties...</span>
              <ArrowForwardIcon
                sx={{ color: "#fff !important", fontSize: "25px" }}
              />
            </Typography>
          </Box>
          <Box pr={2} onClick={handleAddClick}>
            <AddIcon className={classes.icon} />
          </Box>
        </Box>
      </Box>
      <Box pt={2} className={classes.inputContainer}>
        {inputFields.map((field) => (
          <Box key={field.id}>
            {field.isBackground ? (
              <Box pb={2} sx={{ display: "flex", gap: 3 }}>
                <InputBase
                  placeholder="Property Name"
                  className={classes.nameInput}
                  type="text"
                  name="background"
                  label="Outlined"
                />
                <InputBase
                  placeholder="Property Value"
                  className={classes.nameInput}
                  type="text"
                  name="background"
                  value={field.background}
                  onChange={(e) => {
                    handleInputChange(field.id, "background", e.target.value);
                    formik.handleChange(e);
                  }}
                />
              </Box>
            ) : (
              <Box pb={2} sx={{ display: "flex", gap: 3 }}>
                <InputBase
                  placeholder="Property Name"
                  className={classes.nameInput}
                  type="text"
                  name="background"
                  label="Outlined"
                />
                <InputBase
                  placeholder="Property Value"
                  className={classes.nameInput}
                  type="text"
                  value={field.color}
                  name="color"
                  onChange={(e) => {
                    handleInputChange(field.id, "color", e.target.value);
                    formik.handleChange(e);
                  }}
                />
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </>
  );
};

export default Properties;

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "#2A203E !important",
    borderRadius: "10px !important",
  },
  icon: {
    background: "#1976d2",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  propertiesContainer: {
    padding: "15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  nameInput: {
    background: "#2A203E",
    color: "#fff !important",
    fontSize: "18px !important",
    fontWeight: 400 + "!important",
    padding: 15,
    borderRadius: "10px !important",
    width: "100% !important",
    // border: "1px solid #1976d2 !important",
    "&::placeholder": {
      color: "#7c7c7c",
    },
  },
  inputContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  },
}));
